import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import unpermittedAduImage from '@/assets/unpermitted-adu.jpg';

const ADUWithoutPermitConsequencesCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/adu-without-permit-consequences-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={unpermittedAduImage} 
              alt="Unpermitted ADU consequences" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              What Happens If I Build an ADU Without a Permit in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Discover the legal consequences and risks of building an ADU without a permit 
              in California, and how to rectify unpermitted units.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Risks of Building Unpermitted ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Building an ADU without proper permits exposes homeowners to significant risks 
                including code violations, safety hazards, insurance issues, difficulty selling 
                your property, and potential legal liability. Unpermitted structures may not 
                meet current building codes, creating safety risks for occupants.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Legal and Financial Consequences
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Cities can issue stop-work orders, impose heavy fines (often $500-$2,000+ per day), 
                require demolition of unpermitted structures, or place liens on your property. 
                You may face challenges with insurance claims, property sales, and refinancing. 
                Legal liability increases if unpermitted work causes injury or property damage.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Steps to Legalize an Unpermitted ADU in California
              </h2>
              <p className="text-white leading-relaxed mb-6">
                To legalize an unpermitted ADU, you'll need to: submit plans to the building 
                department for retroactive permitting, undergo inspections to verify code 
                compliance, make necessary upgrades to meet current standards, pay applicable 
                fees and penalties, and obtain final approval. Some jurisdictions offer 
                amnesty programs to encourage legalization.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Can the city force me to tear down an unpermitted ADU?</p>
                  <p>A: Yes, cities can issue removal orders or heavy fines for unpermitted ADUs.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: How can I legalize an ADU built without a permit?</p>
                  <p>A: Retroactive permitting involves inspection, fees, and possibly upgrades to meet current codes.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default ADUWithoutPermitConsequencesCalifornia;